<template>
  <div>
    <v-img
        @click="setImageBlock(content)"
        :max-height="content.max_height"
        :max-width="content.max_width"
        :min-height="content.min_height"
        :min-width="content.min_width"
        :src="content.value"
        :lazy-src="content.value"
        class="ls-image"
        :contain="content.contain"
        :style="content.rounded ? 'width:150px; height:150px; border-radius: 150px;': ''"
    ></v-img>
  </div>
</template>

<script>
import store from "@/store/";

export default {
  props: {
    content: Object
  },
  components: {},
  data() {
    return {
      image_dialog: false,
      media_url: process.env.VUE_APP_MEDIA_URL,
    }
  },
  methods: {
    setImageBlock: (item) => {
      let payload = {
        active: true,
        item: item
      }
      store.dispatch('setImageBlock', payload)
    },
  }
}
</script>

